export default __webpack_public_path__ + "static/media/truck.ca98c627.svg";